'use strict';

require('./ca');
require('./da');
require('./de');
require('./es');
require('./fi');
require('./fr');
require('./it');
require('./ja');
require('./ko');
require('./nl');
require('./no');
require('./pl');
require('./pt');
require('./ru');
require('./sv');
require('./zh-CN');
require('./zh-TW');

module.exports = require('sugar-core');


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/locales/index.js
// module id = 417
// module chunks = 0